export {default} from "./IntlMenu";
